import { render, staticRenderFns } from "./upcgenerator.vue?vue&type=template&id=87772806&"
import script from "./upcgenerator.vue?vue&type=script&lang=js&"
export * from "./upcgenerator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports